module.exports = __webpack_public_path__ + "img/Icon - Students.3f782f3f.svg";